"use client";
import React from 'react';

const FormControlContext = React.createContext({
    invalid: false,
    disabled: false,
});
const FormControlProvider = FormControlContext.Provider;

export { FormControlContext, FormControlProvider };
//# sourceMappingURL=FormControlProvider.js.map
